import moment from 'moment';
import BookingMixin from '@/mixins/bookings'
import ConfirmList from '@/components/booqit/confirmList.vue'
import ChooseBooking from '@/components/booqit/chooseBooking.vue'
import RouteMap from '@/components/googlemaps/routeMap'
import ClientsMixin from '@/mixins/clients'
import DestinationsMixin from '@/mixins/destinations'
import { searchItems2 } from '@/utils/helpers'

export default {
  mixins: [ClientsMixin, DestinationsMixin, BookingMixin],
  components: {
    'm-confirm-list': ConfirmList,
    'm-choose-booking': ChooseBooking,
    'm-route-map': RouteMap
  },
  data () {
    return {
      form: {},
      formBooking: {
        dates: [],
        back: false,
        fields: {}
      },
      date_start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      date_end: moment().add(20, 'days').format('YYYY-MM-DD'),
      search_booqits: '',
      search: '',
      options: {},
      componentKey: 0,
      booqit: [],
      booqitInbox: [],
      booqitFilter: [],
      booqitDate: {
        start: null,
        end: null,
      },
      selectedItem: {},
      jsonString: '',
      dialog: false,
      dialog_loader: false,
      dialog_distance: false,
      dialog_destination: false,
      dialog_client: false,
      dialog_booking: false,
      motives: {
        'radiotherapy': 1,
        'kinetherapy': 2,
        'frequentation': 3,
        'consultation': 4,
        'dialysis': 5,
        'chemotherapy': 6,
        'shopping': 7,
        'hospitalisation': 8,
        'other': 0
      },
      headers: [
        { text: '', value: 'back' },
        { text: 'dateTime', value: 'dateTime' },
        { text: 'passenger', value: 'passenger' },
        { text: 'reason', value: 'reason' },
        { text: 'pickup', value: 'pickup' },
        { text: 'dropOff', value: 'dropOff' },
        { text: 'price', value: 'total' },
        { text: 'Actions', value: 'name', sortable: false }
      ],
      booqitUrl: 'https://booqitapp.com/?transportId='
    }
  },
  methods: {
    trips () {
      this.dialog_loader = true;
      this.$http
        .get('service/booqit/trips')
        .then(response => {
          // app.map.renderData(response.data)
          console.log('trips response data', response.data);
          this.parse(response);
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    transports (dates, tags) {
      this.dialog_loader = true;
      this.$http
        .post('service/booqit/transports', {dates, tags})
        .then(response => {
          // app.map.renderData(response.data)
          console.log('transports response data', response.data);
          this.parse(response);
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    transportsById (transportId) {
      this.dialog_loader = true;
      this.$http
        .post('service/booqit/byId', {transportId})
        .then(response => {
          // app.map.renderData(response.data)
          // console.log('transports response data', response.data);
          this.parse(response);
          if (this.booqit[0] && this.booqit[0][0]) {
            this.showRoute (this.booqit[0][0], false);
          }
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    inbox () {
      this.dialog_loader = true;
      this.$http
        .get('service/booqit/inbox')
        .then(response => {
          // app.map.renderData(response.data)
          // console.log('inbox response data', response.data);
          this.parse(response, 'inbox');
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    series () {
      this.dialog_loader = true;
      this.$http
        .get('service/booqit/series')
        .then(response => {
          // app.map.renderData(response.data)
          // console.log('inbox response data', response.data);
          this.parse(response, 'inbox');
          this.dialog_loader = false;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
    },
    viewItem (item) {
      if (item.transportId) {
        window.open(this.booqitUrl + item.transportId, '_blank');
      }
    },
    bookItem (booking) {
      var item = booking[0];
      if (item.client.id && item.destination.id) {
        item.booking.back = (booking[1] && booking[1].booking.type === 'back' && booking[1].status === 'accepted') ? true : false;
        item.booking.clientId = item.client.id;
        item.booking.destinationId = item.destination.id;
        this.selectedItem = item.booking;
        this.dialog_booking = true;
        console.log('book item', item)
      }
    },
    checkItem (item) {
      this.dialog_distance = true;
      this.$refs.distanceCheck.showTrip({
        pickup: item.client.address + ' ' + item.client.city,
        dropOff: item.destination.address + ' ' + item.destination.city
      })
    },
    showRoute (item) {
      var route = [
        'Rue Henri evenenpool 98, 1030 Schearbeek',
        item.client.address + ' ' + item.client.city,
        item.destination.address + ' ' + item.destination.city
      ]
      this.$refs.routeMap.show(route);
    },
    getData () {
      if (localStorage.getItem('booqit')) {
        this.booqit = JSON.parse(localStorage.getItem('booqit'));
        // console.log(this.booqit);
      }
      if (localStorage.getItem('booqitFilter')) {
        this.booqitFilter = JSON.parse(localStorage.getItem('booqitFilter'));
        console.log('booqitFilter', this.booqitFilter);
      }
      if (localStorage.getItem('booqitDate')) {
        this.booqitDate = JSON.parse(localStorage.getItem('booqitDate'));
        console.log('booqitDate', this.booqitDate);
      }
      console.log('getData');
    },
    onClose () {
      this.dialog = false
      this.dialog_distance = false
      this.dialog_destination = false
      this.dialog_client = false
      this.dialog_booking = false
    },
    clear () {
      this.booqit = [];
    },
    onSaveDestination (data) {
      this.saveDestination(data, (id) => {
        console.log('saveDestination', this.selectedItem)
        this.selectedItem.id = id;
        this.forceRerender();
      })
    },
    onSaveClient (data) {
      this.saveClient(data, (id) => {
        console.log('saveDestination', this.selectedItem)
        this.selectedItem.id = id;
        this.forceRerender();
      })
    },
    parse (result) {
      if (result && result.data && (result.data.transports || result.data[0])) {
        var data = result.data.transports ? [result.data.transports] : result.data;
        console.log(data);
        this.booqit = data
        .filter((task) => {
          var status = task[0] && task[0].status;
          // toConfirmDelete
          return (
            status !== 'cancelledByBooker' &&
            status !== 'cancelledByTransporter' &&
            status !== 'toConfirmDelete'
          )
        })
        .map((task) => {
          this.dialog = false;
          return task.map((item) => {
            var price = this.calculatePrice(item);
            return {
              transportId: item.transportId,
              dateTime: item.request.dateTime || null,
              reason: item.request.reason,
              passenger: item.request.passenger.lastName ? (item.request.passenger.firstName + ' ' + item.request.passenger.lastName) : '',
              pickup: (item.request.pickup.name || item.request.pickup.street) + ' ' + item.request.pickup.zipCode + ' ' + item.request.pickup.locality,
              dropOff: (item.request.dropOff.name || item.request.dropOff.street) + ' ' + item.request.dropOff.zipCode + ' ' + item.request.dropOff.locality,
              distance: item.request.distance,
              status: item.status,
              // price: item.matchingState.price,
              price: (item.assignment.price && item.assignment.price.total) || null,
              total: price,
              rejectedDrivers: item.matchingState.rejectedDrivers,
              client: this.mapClient(item.request),
              destination: this.mapDestination(item.request),
              booking: this.mapBooking(item, task),
              isDone: false
            }
          });
        });
        console.log('parse', this.booqit);
      }
    },
    getBookingByTransportIds (transportId) {
      var app = this;
      this.loading = true;
      this.$http
      .post('service/booking/byTransportIds', {transportIds : [transportId]})
      .then(response => {
        console.log('getBookingByTransportIds data', response.data);
        app.loading = false;

        if (response.data[0]) {
          app.$refs.chooseBooking.open(response.data).then((result) => {
            if (result) {
              var d = result;
              d.ap_date = app.$options.filters.date(d.ap_date)
              d.json = JSON.parse(d.distance)
              this.selectedItem = d;
              this.dialog_booking = true;
            }
          })
        }
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    checkBookings () {
      var app = this;
      this.dialog_loader = true;
        this.$http
        .post('service/booking/byDate', {
          startDate: app.date_start,
          endDate: app.date_end || app.date_start
        }).then(response => {

          this.booqit.map(item => {
            item[0].isDone = response.data.some((o) => {
              var dateOK = false, birtDayOK = false, ssnOK = false;

              if (o.ap_date) {
                dateOK = moment(o.ap_date).format('DD/MM/YYYY') === item[0].booking.ap_date;
              }

              if (dateOK) {
                if (o.client_ssn && item[0].client.ssn) {
                  // console.log(o.client_ssn.replace(/-|\/|\./g, ''), ' === ', item[0].client.ssn.replace(/-|\/|\./g, ''))
                  ssnOK = o.client_ssn.replace(/-|\/|\./g, '') === item[0].client.ssn.replace(/-|\/|\./g, '');
                } else if (o.client_birthday) {
                  birtDayOK = o.client_birthday.replace(/-|\//g, '') === item[0].client.birthday;
                }
                return (birtDayOK || ssnOK);
              } else {
                return false;
              }
            })
          })
          this.dialog_loader = false;
          console.log('booqit:', this.booqit);
        })
    },
    mapDestination (request) {
      var address = this.isDischargeAddress(request, false) // (request, isClient))
      var destination = {
        id: null,
        address: request[address].street + ' ' + request[address].number,
        city: request[address].locality,
        fullAddress: this.fullAddress(request[address]),
        latitude: request[address].coordinates[1],
        longitude: request[address].coordinates[0],
        name: request[address].name,
        tel: request[address].phoneNumber,
        zip: request[address].zipCode
      }
      return destination;
    },
    mapClient (request) {
      var address = this.isDischargeAddress(request, true) // (request, isClient))
      var client = {
        id: null,
        address: request[address].street + ' ' + request[address].number,
        postbox: request[address].box,
        city: request[address].locality,
        zip: request[address].zipCode,
        latitude: request[address].coordinates[1],
        longitude: request[address].coordinates[0],
        fullAddress: this.fullAddress(request[address]),
        birthday: request.passenger.dateOfBirth,
        client_from: 'Mutas',
        email: request.passenger.email,
        firstname: request.passenger.firstName || '',
        lastname: request.passenger.lastName || '',
        mcode: request.passenger.mutuality,
        mobile: request.passenger.phoneNumber,
        ssn: request.passenger.rrNumber,
        comment: request.info ? request.info : null

        // returnAmbulatoryCare, discharge
      }
      client
      return client;
    },
    mapBooking (item, task) {
      var date = moment(item.request.dateTime);
      var booking = {
        driverId: null,
        ap_date: date.format('DD/MM/YYYY'),
        ap_time: date.format('HH:mm'),
        dates: [date.format('YYYY-MM-DD')],
        motive: this.motives[item.request.reason] || 0,
        type: this.isReturn(item) ? 'back' : 'to'
      }
      booking = this.mapMutuality(booking, item, task);
      return booking;
    },
    mapMutuality (booking, item, task) {
      let mutual = {};
      const price = this.calculatePrice(item);
      const multiply = (task && task[1] && task[1].status === 'accepted' && task[1].returnPart === 2) ? 2 : 1;
      let nonReimbursed = (item.assignment.price && item.assignment.price.distribution && item.assignment.price.distribution.nonReimbursed) || {}
      let clientPrice = price;
      if(nonReimbursed.perDay || nonReimbursed.perPart >= 0) {
        if (!nonReimbursed.perDay && nonReimbursed.perPart == 0) {
          clientPrice = 0;
        } else {
          clientPrice = (nonReimbursed.perDay || (nonReimbursed.perPart * multiply))
        }
      }

      if (this.isMutuality(item, price, clientPrice)) {
        mutual = {
          insuranceId: 1,
          mutualPatientID: item.transportId,
          mutualPatientAmount: clientPrice,
          mutualAmount: price,
          mutualDistance: item.request.distance && Math.ceil(item.request.distance / 1000),
          certificateNeeded: item.certificateNeeded || null,
          nonReimbursed: nonReimbursed
        }
      }

      return {...booking, ...mutual};
    },
    calculatePrice (item) {
      if (item.matchingState.price) {
        return item.matchingState.price.total
      } else {
        if (item.request.distance) {
          var distance = item.request.distance
          return this.calcTarif(distance)
        }
      }
    },
    calcTarif (distance) {
      var d = Math.ceil(distance / 1000);
      var forfait10km = 16;
      var from11to30 = 0;
      var above30 = 0;
      d -= 10;
      if (d > 0) {
        if (d > 20) {
          from11to30 = 20 * 1.78;
          above30 = (d - 20) * 1.2;
        } else {
          from11to30 = (d * 1.78);
        }
      }
      /*
      {label: "forfait10km", km: 10, costTotal: 16}
      {label: "from11to30", km: 20, costUnit: 1.78, costTotal: 35.6}
      {label: "above30", km: 64, costUnit: 1.2, costTotal: 76.8}
      */
      return (Math.round((forfait10km + from11to30 + above30) * 100) / 100).toFixed(2);
    },
    isMutuality (item, price, priceClient) {
      return (
        item.request.reason === 'chemotherapy' ||
        item.request.reason === 'dialysis' ||
        item.request.reason === 'radiotherapy' ||
        item.request.reason === 'postTreatmentKidneyTransplantation' ||
        item.tags.indexOf("invoiceable") > -1 ||
        priceClient < price
      );
    },
    isReturn (item) {
      return (this.isDischarge(item.request) || item.returnPart === 2);
    },
    isDischarge (request) {
      return (request.reason === 'returnAmbulatoryCare' || request.reason === 'discharge');
    },
    isDischargeAddress (request, isClient) {
      var discharge = this.isDischarge(request);
      if (isClient) {
        return discharge ? 'dropOff' : 'pickup'
      } else {
        return discharge ? 'pickup' : 'dropOff'
      }
    },
    fullAddress (data) {
      var adr = data.street + ' ' + (data.number || '') + ', ' + data.zipCode + ' ' + data.locality
      return adr
    },
    forceRerender () {
      console.log('forceRerender');
      this.componentKey += 1;
    },
    expandme (item) {
      item[0].expanded = !item[0].expanded;
      this.forceRerender();
    },
    checkOnES (item, mode) {
      var search = (mode === 'client')
      ? this.querySearch('client ' + item.client.lastname + ' ' + item.client.firstname)
      : this.geoSearch({lat: item.destination.latitude, lon: item.destination.longitude});

      search.then((result) => {
        var items = result.hits.hits.map(hit => { return hit._source });
        if (items[0] && items[0].id) {
          console.log('Item Exist:', items);
          this.$refs.confirm.open(items).then((result) => {
            if (result.id) {
              item[mode].id = result.id;
              console.log('save id:', result.id);
              this.forceRerender();
            } else if (result === 'new') {
              this.selectedItem = item[mode]
              this['dialog_' + mode] = true;
            }
          })
        } else {
          console.log('Not Existing:', item);
          this.selectedItem = item[mode]
          this['dialog_' + mode] = true;
        }
      })
    },
    geoSearch: function (geo) {
      console.log('geo search', geo);
      return new Promise((resolve) => {
        if (geo.lat && geo.lat !== '') {
          this.isLoading = true
          this.$http
          .post('service/search/geo', {
            lat: geo.lat,
            lon: geo.lon
          })
          .then(response => {
            this.isLoading = false;
            resolve(response.data)
          })
        } else {
          resolve(null)
          console.log('search: empty');
        }
      })
    },
    querySearch: function (q) {
      console.log('query search', q);
      return new Promise((resolve) => {
        if ((typeof q === 'string' || q instanceof String) && q !== '') {
          this.isLoading = true
          this.$http
          .post('service/search/all', {
            q: q
          })
          .then(response => {
            this.isLoading = false;
            resolve(response.data)
          })
        } else {
          resolve(null)
          console.log('search: empty');
        }
      })
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    booqit: {
      handler (updatedList) {
        console.log('updated localStorage');
        localStorage.setItem('booqit', JSON.stringify(updatedList));
      },
      deep: true
    },
    booqitInbox: {
      handler (updatedList) {
        localStorage.setItem('booqitInbox', JSON.stringify(updatedList));
      },
      deep: true
    },
    booqitFilter: {
      handler (updatedList) {
        localStorage.setItem('booqitFilter', JSON.stringify(updatedList));
      },
      deep: true
    },
    booqitDate: {
      handler (date) {
        localStorage.setItem('booqitDate', JSON.stringify(date));
      },
      deep: true
    }
  },
  computed: {
    filteredBooqit () {
      return searchItems2(this.booqit, this.search_booqits);
    }
  },
  created () {
  },
  mounted () {
    this.getData();
    this.dateFormatted_start = this.formatDate(this.booqitDate.start);
    this.dateFormatted_end = this.formatDate(this.booqitDate.end);
  },
  beforeDestroy () {
  }
}
